import { createFileRoute } from '@tanstack/react-router';

import { WafLogTable } from 'component/partial/tables/logs/WafLog/WafLogTable';

export const Route = createFileRoute('/n/_auth/sites/$siteId/_details/logs/waf-log')({
  component: WafLogRoute,
});

function WafLogRoute() {
  return <WafLogTable />;
}
